import React, {useContext, useEffect, useState} from "react";
import {Col, Menu, Row, Radio, Avatar, Tag, Drawer, Timeline, Button, Typography, Switch, FloatButton} from "antd";
import {
    ClockCircleOutlined,
    HomeOutlined,
    LogoutOutlined,
    ReloadOutlined,
    UserOutlined,
    BarChartOutlined,
    MoonFilled,
    SunFilled
} from "@ant-design/icons";

import {Link, useLocation} from "react-router-dom";
import {Header} from "antd/es/layout/layout";
import {AuthContext} from "../context/AuthContext";
import { useTranslation } from 'react-i18next';

import './comp.css'
import {useAuth} from "../hooks/auth.hook";
import UserProfile from "./User/UserProfile";
import dayjs from "dayjs";
import ChartDrawer from "./charts/ui/ChartDrawer";
import {useTheme} from "../context/ThemeContext";
import {useTitle} from "../context/TitleContext";

const { Title, Text } = Typography;



const NavigationBar = () => {

//    dayjs.locale('ru');
    /* Chart*/
    const [open, setOpen] = useState(false);
    /* Chart*/
    const location = useLocation();

    const {isDarkMode, toggleDarkMode,setIsDarkMode} = useTheme()
    const auth = useContext(AuthContext);
    const isAuthenticated = !!auth.token;

    const {empId, empName} = useAuth();
    const { t, i18n } = useTranslation();
    const { titleNav } = useTitle();
    const [selectedLang, setSelectedLang] = useState(() => {
        return localStorage.getItem('lang') || 'Uz';
    });


    const [openProfile, setOpenProfile] = useState(false)
    const [currentTime, setCurrentTime] = useState(dayjs());

    const showProfile = () => { setOpenProfile(true) }
    const closeProfile = () => { setOpenProfile(false) }

    const handleLogOut = () => {
        auth.logout()
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(dayjs());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    if (!isAuthenticated || location.pathname === '/') {
        return null;
    }

    const handleExtraButtonClick = () => {
        window.onbeforeunload = null;

        window.location.reload(true);
    }

    const handleTheme = () => {

        toggleDarkMode()
        //setIsDarkMode(prevState => !prevState);
    }

    const handleChangeLang = () => {
        const lang = selectedLang === 'Uz' ? 'Ru' : 'Uz';
        setSelectedLang(lang);
        i18n.changeLanguage(lang.toLowerCase())
        localStorage.setItem('lang',lang);
    }

    const items = [
        {
            key: 'dateTime',
            icon: <ClockCircleOutlined />,
            label: currentTime.format('DD MMM YYYY HH:mm:ss'),
        },
        {
            key: 'employee',
            label: (
                <Tag
                    color="#707070"
                    style={{
                        padding: '4px 10px',
                        color: 'inherit',
                        fontSize: '14px',
                        backgroundColor: "transparent",
                        //borderColor: "#0985bc", //#kmbat
                        //borderColor: "#00c950", //#agro bank
                        borderColor: "#E8A020", //#Mbilling
                        //borderColor: "#09A4A4" //#kadastr
                    }}
                >
                    <UserOutlined style={{ marginRight: '6px' }} /> {empId} - {empName}
                </Tag>
            ),
            onClick: showProfile,
        },
        {
            key: 'lang',
            title: t('lang'),
            label: (
                <span onClick={handleChangeLang}
                >
                    {selectedLang}
                </span>
            ),

        },
        {
            key: 'reload',
            /*icon: <ReloadOutlined title={t('refresh')}/>,*/
            title: t('refresh'),
            label: (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleExtraButtonClick();
                    }}
                >
                    <ReloadOutlined title={t('refresh')} size={'large'} />
                    {/*{t('refresh')}*/}
                </a>
            ),
        },
        {
            key: 'charts',
            //icon: <BarChartOutlined />,
            title: t('Диаграмма'),
            label: (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setOpen(true);
                    }}
                >
                    <BarChartOutlined  />
                    {/*{t('Диаграмма')}*/}
                </a>
            ),
        },
        {
            key: 'layout',
            //icon: <HomeOutlined />,
            title: t('homeWindow'),
            //label: <Link to="/layout">{t('homeWindow')}</Link>,
            label: <Link to="/layout"><HomeOutlined /></Link>,
        },
        {
            key: 'login',
            /*icon: <LogoutOutlined />,*/
            title: t('exit'),
            //label: <Link to="/" onClick={handleLogOut}>{t('exit')}</Link>,
            label: <Link to="/" onClick={handleLogOut}><LogoutOutlined /></Link>,
            style: {display: 'block !important'}
        },
    ];


    return (
        <Header className="header" theme="light"
                style={{
                    //backgroundColor: "#262626"//#KMBAT AND OTHERS*/
                    //backgroundColor: "#262626"//#Mbilling*/
                }}
        >

            <Row>
                <Col span={4}>
                    {/*<h2 style={{color: '#f2f9fa', fontWeight: 600}} className="logonav"><span className="logoApp"/> <span>KMBAT</span></h2>*/}
                    {/*<h3 style={{color: '#f2f9fa', fontWeight: 600}} className="logonav"><span className="logoAppAB"/><span>AGROBANK</span></h3>*/}
                    <h3 style={{color: '#f2f9fa', fontWeight: 600}} className="logonav">
                        {/*<span className="logoAppMB"/>*/}
                        <div
                            style={{
                                fontSize: 20,
                                background: '#E8A020',
                                width: 32,
                                height: 32,
                                borderRadius: 8,
                                display: 'flex',
                                fontWeight: '500',
                                color: '#000',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: 4,
                            }}
                        >
                            M
                        </div>
                        <span className="logoAppMBText">M<span>Billing</span></span>
                    </h3>
                    {/*<h3 style={{color: '#f2f9fa', fontWeight: 600}} className="logonav"><span className="logoAppKD"/><span style={{marginLeft: 8}}>KADASTR</span></h3>*/}
                    {/*<h2 style={{color: '#f2f9fa', fontWeight: 600}} className="logonav"><span className="logoAppBi"/> <span>QUERY BI</span></h2>*/}

                </Col>

                <Col span={6}>

                    <Title
                        level={5}
                        style={{ width: 400,
                            //color: '#35bbf8', //#kmbat
                            //color: '#f0fdf4', //#agrobank
                            color: '#f0fdf4', //#mbilling
                            //color: '#f0fdf4', //#kadastr
                            paddingTop:'20px'}}
                        ellipsis={{tooltip: t(titleNav)}}
                    >
                        {t(titleNav)}
                    </Title>
                </Col>
                <Col span={14} style={{float: 'right'}}>
                    <FloatButton
                        onClick={handleTheme}
                        style={{
                            left: 20,
                            bottom: 60
                        }}
                        shape="square"
                        type="default"
                        icon={isDarkMode ? <SunFilled /> : <MoonFilled />}
                    />

                        <Menu theme="dark" items={items} mode="horizontal" defaultSelectedKeys={['welcome']} selectable={false}
                              style={{
                                  justifyContent: 'flex-end',
                                  //backgroundColor:"#262626" //#kmbat and others
                                  //backgroundColor:"#262626" //Mbilling
                                }}
                        />

                    <ChartDrawer open={open} setOpen={setOpen}/>
                    <Drawer
                        title={t("user")}
                        width={600}
                        placement='right'
                        onClose={closeProfile}
                        open={openProfile}
                        /*styles={{
                            paddingBottom: 110,
                        }}*/
                    >
                        <UserProfile empId={empId}/>

                    </Drawer>

                </Col>

            </Row>
        </Header>
    )
}

export default NavigationBar;